import type { Resource } from '../../';
export const product_details_color: Resource = {"default":"Color:"};
